module.exports = __webpack_public_path__ + "img/sdw.1c9568ba.png";